import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//积分规则
export const getConfigList = data => http.get('/mini/Config');

//明细
export const getUserScoreList = data => http.get('/mini/UserScore');

//赚积分
export const getUserScoreTask = data => http.get('/mini/UserScore/task');

//7天签到记录
export const getSign = data => http.get('/mini/Sign');
